import { Fragment } from 'react';
import {
  MODEL_PRICING_COLUMNS,
  MODEL_PRICING_DATA_NEW,
  SVG_SIZE_M,
} from 'src/constants';
import { Icon, IconName } from 'src/components/Icon';
import styles from './ModelPricingTable.module.scss';
import { ModelPricingDesktopRow } from '../ModelPricingDesktopRow';

export const ModelPricingTable = () => {
  const columns = MODEL_PRICING_COLUMNS;

  return (
    <div className={styles.root}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.row}>
            {columns.map((col) => (
              <th key={col.key} className={styles.headCell}>
                {col.header}{' '}
                {col.caption && (
                  <>
                    /<span className={styles.caption}>{col.caption}</span>
                  </>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {MODEL_PRICING_DATA_NEW.map(
            ({ companyName, companyLogo, models }, rowIndex) => {
              return (
                <Fragment key={rowIndex}>
                  <tr className={styles.row}>
                    <td className={styles.companyName}>
                      <Icon type={companyLogo as IconName} size={SVG_SIZE_M} />
                      {companyName}
                    </td>
                  </tr>
                  {models.map(
                    (
                      {
                        modelName,
                        inputPrice,
                        outputPrice,
                        currency,
                        // price,
                        modelDescription,
                        defaultModels,
                      },
                      modelIndex,
                    ) => (
                      <ModelPricingDesktopRow
                        key={modelIndex}
                        modelName={modelName}
                        inputPrice={inputPrice}
                        outputPrice={outputPrice}
                        // price={price}
                        currency={currency}
                        modelDescription={modelDescription}
                        defaultModels={defaultModels}
                      />
                    ),
                  )}
                </Fragment>
              );
            },
          )}
        </tbody>
      </table>
    </div>
  );
};
